/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, Inject, OnInit } from '@angular/core';
import { CurateSearchVm } from '../../../models/curate-search-vm';
import { Observable, Subscription } from 'rxjs';
import { CURATE_SEARCH_FACADE_TOKEN ,ICurateSearchFacade} from '../../../../../../../toolbelt/data-access/src/lib/domain/facades-models/curate-search-facade-interface';
import { LocalStorageService } from '../../../../../../utils/src/lib/local-storage/local-storage.service';
import { GlobalConstants } from '../../../constants/global-constants';
import { SysqueElectricalState } from '../../../models/sysque-electrical-state';

@Component({
  selector: 'sysque-curate-search',
  templateUrl: './curate-search.component.html',
  styleUrls: ['./curate-search.component.scss'],
  standalone: false
})
export class CurateSearchComponent implements OnInit {
  curateSearchVm: CurateSearchVm = new CurateSearchVm();;
  curateSearchOptions$: Observable<any>;
  curateSearchOptionsSub: Subscription;
  groups = [];
  installTypes = [];
  manufacturers = [];
  productTypes = [];
  subProductTypes = [];
  materialTypes = [];
  isSearchButtonDisabled: boolean = true;
  showClearButton = true;
  decodedImage: string | ArrayBuffer | null = null;
  public isLicenseValid: boolean;
  public reporIssueTooltip = GlobalConstants.FeatureIncludedOnlyInSubscription;
  public releaseVersion: string;

  private excludedVersions = [ '11.4', '11.4.1' ];
  private state: SysqueElectricalState;

  constructor(@Inject(CURATE_SEARCH_FACADE_TOKEN)public curateSearchFacade: ICurateSearchFacade, private localStorageService: LocalStorageService) { }

  public async ngOnInit(): Promise<void> {
    this.curateSearchOptions$ = this.curateSearchFacade.getCreateSearchOptions(); 
    this.curateSearchOptionsSub = this.curateSearchOptions$.subscribe((data) => {
      const sortByName = (a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase());
      this.groups = data.groups?.sort(sortByName);
      this.installTypes = data.installTypes?.sort(sortByName);
      this.manufacturers = data.manufacturers?.sort(sortByName);
      this.productTypes = data.productTypes?.sort(sortByName);
      this.subProductTypes = data.subProductTypes?.sort(sortByName);
      this.materialTypes = data.materialTypes?.sort(sortByName);
    });
    
    this.state = this.curateSearchFacade.getLocalStorage(GlobalConstants.SYSQUE_ELECTRICAL_STATE_KEY);
    this.isLicenseValid = this.state.isLicenseValid;
    this.releaseVersion = this.state.releaseVersion;
  }

  onValueChanged(e: any, collection: any[], d: string) {
    if (!e.value) {
      this.curateSearchVm[d] = null;
      this.setSearchButtonVisibility();
      return;
    }
    var item =  collection.find(x => e.value === x.name)
    if(item.hasOwnProperty('id')) {
      this.curateSearchVm[d] =  item.id;
    }

    if(item.hasOwnProperty('ids')) {
      this.curateSearchVm[d] =  item.ids;
    }

    this.setSearchButtonVisibility();
  }

  onUpdateSearchValue(e: any) {
    this.curateSearchVm.searchWords = e;
    this.setSearchButtonVisibility();
  }

  onSearchClick() {
    const state = this.localStorageService.getStorage(GlobalConstants.SYSQUE_ELECTRICAL_STATE_KEY);
    this.curateSearchFacade.notifySearchFor(this.curateSearchVm, state.systemList[0].unitType);
  }

  public onRequestNewContent() {
    this.curateSearchFacade.showRequestNewContent();
  }

  public isReleaseVersionValid(): boolean {
    return this.releaseVersion && !this.excludedVersions.includes(this.releaseVersion);
  }

  setSearchButtonVisibility() {
    const check =
      Object.keys(this.curateSearchVm).filter((k) => 
        k !== 'recordCount' &&
          k !== 'startRecordIndex' &&
          k !== 'discontinued' &&
          this.curateSearchVm[k] &&
          this.curateSearchVm[k] &&
          this.curateSearchVm[k] !== ''
      ).length > 0;

    if (check) {
      this.isSearchButtonDisabled = false;
    } else {
      this.isSearchButtonDisabled = true;
    }
  }
}
